import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { ExportModelModalComponent } from './export-model-modal';

@NgModule({
	declarations: [ExportModelModalComponent],
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		AnalyticsModule,
		DzButtonModule,
		GenericDirectivesModule,
		DomModule,
		DzProgressSpinnerModule
	],
	exports: [ExportModelModalComponent]
})
export class ExportModelModule { }
